export default __webpack_public_path__ + "static/media/space-station.7a027c6e.svg";